/**
 * Converts and RGB string value to a lowercased hex value
 *
 * @category Color
 * @param {string} rgb - Prefix for naming the two session keys that cache the token.
 * @returns {string} - A lowercased hex value of the RGB color passed in.
 * @example rgbToHex('rgb(52, 122, 190)') //=> '#347abe'
 * @docgen_example rgbToHex('rgb(52, 122, 190)')
 */
export var rgbToHex = function (rgb) {
    var matchArray = rgb.match(/\d+/g);
    if (!matchArray || matchArray.length !== 3) {
        throw new Error('Invalid RGB format');
    }
    var componentToHex = function (c) {
        var hex = c.toString(16);
        return hex.length === 1 ? '0' + hex : hex;
    };
    var _a = matchArray.map(Number), r = _a[0], g = _a[1], b = _a[2];
    return "#".concat(componentToHex(r)).concat(componentToHex(g)).concat(componentToHex(b)).toLowerCase();
};
